module.exports = __webpack_public_path__ + "img/DS925+.9ac6e65b.png";